module.exports = __webpack_public_path__ + "static/media/thanks-for-your-purchase.053f6bca.svg";